(function () {
  'use strict';

  var megaOpenClass = 'is-open';
  var triggerOpenClass = 'is-menu-open';
  var bodyOpenClass = 'diagnox-mega-open';
  var activeClass = 'is-active';

  function initDiagnoxHeader() {
    var header = document.querySelector('.diagnox-header');
    if (!header) return;

    var panel = header.querySelector('.diagnox-mega-menu');
    var triggers = header.querySelectorAll('[data-diagnox-menu-trigger]');
    if (!panel || !triggers.length) return;

    var closeTimer;
    var mainLinks = panel.querySelectorAll('.diagnox-mega-menu__main-link');
    var contentPanels = panel.querySelectorAll('[data-mega-panel]');

    function setActiveLink(activeLink) {
      var targetId = activeLink && activeLink.getAttribute('data-mega-panel-target');
      contentPanels.forEach(function (sub) {
        var isActive = targetId && sub.id === targetId;
        sub.classList.toggle(activeClass, isActive);
        sub.hidden = !isActive;
      });
      mainLinks.forEach(function (link) {
        var active = link === activeLink;
        link.classList.toggle(activeClass, active);
        link.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function initPanels() {
      var defaultTarget = panel.getAttribute('data-mega-default-sub');
      if (defaultTarget) {
        var defaultLink = panel.querySelector('[data-mega-panel-target="' + defaultTarget + '"]');
        if (defaultLink) {
          setActiveLink(defaultLink);
          return;
        }
      }
      var firstPanelLink = panel.querySelector('[data-mega-panel-target]');
      if (firstPanelLink) setActiveLink(firstPanelLink);
    }

    function openMenu() {
      clearTimeout(closeTimer);
      panel.classList.add(megaOpenClass);
      document.body.classList.add(bodyOpenClass);
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
        t.classList.add(triggerOpenClass);
      });
    }

    function closeMenu() {
      panel.classList.remove(megaOpenClass);
      document.body.classList.remove(bodyOpenClass);
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        t.classList.remove(triggerOpenClass);
      });
    }

    function scheduleClose() {
      closeTimer = setTimeout(closeMenu, 150);
    }

    initPanels();

    mainLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        setActiveLink(link);
      });
      link.addEventListener('focus', function () {
        setActiveLink(link);
      });
      link.addEventListener('click', function (evt) {
        if (
          link.getAttribute('data-mega-panel-target') &&
          window.matchMedia('(max-width: 768px)').matches
        ) {
          evt.preventDefault();
          setActiveLink(link);
        }
      });
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (panel.classList.contains(megaOpenClass)) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      trigger.addEventListener('mouseenter', function () {
        if (
          window.matchMedia('(min-width: 769px)').matches &&
          trigger.classList.contains('diagnox-header__menu-trigger')
        ) {
          openMenu();
        }
      });
    });

    var hoverZone = header.querySelector('.diagnox-header__menu-zone');
    if (hoverZone) {
      hoverZone.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 769px)').matches) {
          clearTimeout(closeTimer);
          openMenu();
        }
      });
      hoverZone.addEventListener('mouseleave', function () {
        if (window.matchMedia('(min-width: 769px)').matches) {
          scheduleClose();
        }
      });
    }

    panel.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });

    panel.addEventListener('mouseleave', function () {
      if (window.matchMedia('(min-width: 769px)').matches) {
        scheduleClose();
      }
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && panel.classList.contains(megaOpenClass)) {
        closeMenu();
        triggers[0] && triggers[0].focus();
      }
    });

    document.addEventListener('click', function (evt) {
      if (!panel.classList.contains(megaOpenClass)) return;
      if (header.contains(evt.target) || panel.contains(evt.target)) return;
      closeMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDiagnoxHeader();
      initMenuAccordions();
    });
  } else {
    initDiagnoxHeader();
    initMenuAccordions();
  }

  function initMenuAccordions() {
    var boxes = document.querySelectorAll('.menu_acc__box');
    boxes.forEach(function (box) {
      var titles = box.querySelectorAll('.menu_acc__title');
      titles.forEach(function (title) {
        if (title._accInit) return;
        title._accInit = true;

        var target = title.nextElementSibling;
        if (!target || !target.classList.contains('acc__hides')) return;

        target.style.overflow = 'hidden';
        target.style.maxHeight = 'none';
        target.style.opacity = '1';

        title.style.cursor = 'pointer';
        title.setAttribute('role', 'button');
        title.setAttribute('aria-expanded', 'true');

        title.addEventListener('click', function () {
          var isOpen = title.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            target.style.transition = 'none';
            target.style.maxHeight = target.scrollHeight + 'px';
            target.offsetHeight;
            target.style.transition = 'max-height .35s ease, opacity .3s ease';
            target.style.maxHeight = '0';
            target.style.opacity = '0';
            title.setAttribute('aria-expanded', 'false');
          } else {
            target.style.transition = 'max-height .35s ease, opacity .3s ease';
            target.style.maxHeight = target.scrollHeight + 'px';
            target.style.opacity = '1';
            title.setAttribute('aria-expanded', 'true');
            target.addEventListener('transitionend', function handler() {
              if (title.getAttribute('aria-expanded') === 'true') {
                target.style.maxHeight = 'none';
              }
              target.removeEventListener('transitionend', handler);
            });
          }
        });
      });
    });
  }

  function initAll() {
    initDiagnoxHeader();
    initMenuAccordions();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
